<template>
  <div class="duplicateremovalPending">
    <el-dialog :visible.sync="duplicateremovalPendingVisible" center :show-close="true"
               custom-class="duplicateremovalPending" :before-close="handleClose">
      <template slot="title">
        <DialogsHeader
                       :titleHtml="`${$t('memoryBankV2.Pending')}<em>${totalRows}</em>${$t('memoryBankV2.strip')}`" />
      </template>
      <div class="duplicateremovalPending-content">
        <ul ref="contentWarpp">
          <li v-for="(item,index) in pendingList" :key="index">
            <div class="source">
              <div class="source-l">
                <div class="source-box">{{$t('memoryBankV2.originText')}}{{index+1}}</div>
                <el-tooltip effect="dark" :disabled="showTitle" :content="item.sourceSent"
                            placement="top-start">
                  <span class="source-content"
                        @mouseover="mouseOverShowTips($event)">{{item.sourceSent}}</span>
                </el-tooltip>
              </div>
              <div class="source-r">
                <el-tooltip effect="dark" :disabled="showTitle"
                            :content="fromatelangDesc(item.langDesc,item.sourceLang,item.targetLang)"
                            placement="top-start">
                  <div class="lang sourec-item" @mouseover="mouseOverShowTips($event)">
                    {{$i18n.locale === 'zh' ? item.langDesc.replace('>'," — ") : $langCase[item.sourceLang] + ' — ' + $langCase[item.targetLang] }}
                  </div>
                </el-tooltip>
                <div class="domain-code sourec-item">
                  {{$i18n.locale === 'zh' ? item.domainName : $domainCase[item.domainCode]}}</div>
              </div>
            </div>
            <div class="target-table">
              <el-table border height="100%" :data="item.targetSentList"
                        header-row-class-name="tableheader">
                <el-table-column type="index" :index="indexMethod"
                                 :label="$t('memoryBankV2.number')" width="57" align="center"
                                 :show-overflow-tooltip="true" />
                <el-table-column prop="target" :label="$t('memoryBankV2.Translationresults')"
                                 align="center" :show-overflow-tooltip="true">
                  <template slot-scope="{ row }">
                    <div class="target-content" :contenteditable="contenteditable"
                         @dblclick="handlerEditor(row,$event)">
                      {{row.targetSent}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="select" align="center" :show-overflow-tooltip="true">
                  <template slot="header">
                    <p>{{$t('memoryBankV2.Selectthetranslationtoberetained')}} </p>
                  </template>
                  <template slot-scope="{row}">
                    <el-checkbox v-model="row.check"></el-checkbox>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </li>
        </ul>
      </div>
      <template slot="footer">
        <el-button size="small" @click="handleClose">{{$t('projectV2.later')}}</el-button>
        <el-button size="small" type="primary" @click="handle">
          {{$t('memoryBankV2.handle')}}</el-button>
      </template>
    </el-dialog>
    <!-- 处理成功 -->
    <duplicateremovalsuccess-dialog :duplicateremovalsuccessVisible="duplicateremovalsuccessVisible"
                                    @handleClose="closeduplicateremoval">

    </duplicateremovalsuccess-dialog>
  </div>
</template>
<script>
//标题组件
import DialogsHeader from '@/common/dialogsHeader';
import DuplicateremovalsuccessDialog from "../components/duplicateremovalsuccessDialog.vue";
import {
  memoryDeduplication,
  DeleteByIdList,
  updateMemoryBank
}
  from "@/services/memoryBank"
import {
  termDeduplication,
  termDeleteByIdList,
  updateTermBanks
}
  from "@/services/term"
import debounce from "lodash.debounce";
export default {
  name: "duplicateremovalPending",
  data() {
    return {
      pendingList: [

      ],
      params: {
        page: 1,
        rows: 10
      },
      totalPage: 0,
      totalRows: 0,
      duplicateremovalsuccessVisible: false,
      showTitle: false,
      contenteditable: false
    }
  },
  components: {
    DialogsHeader,
    DuplicateremovalsuccessDialog
  },
  props: {
    duplicateremovalPendingVisible: {
      type: Boolean,
      required: true
    },
    bankType: {
      type: String,
      default: "memory"
    }
  },
  watch: {
    duplicateremovalPendingVisible: {
      handler(value) {
        if (value) {
          this.$nextTick(() => {
            const contentWarpp = this.$refs.contentWarpp;
            contentWarpp.addEventListener('scroll', debounce(this.handlerScroll, 1000))
          })
        }
      }
    }
  },
  methods: {
    handlerEditor(row, el) {
      this.contenteditable = true;
      let fouceText = el.target.innerText
      el.target.addEventListener("blur", async () => {
        this.contenteditable = false;
        let res = null;
        let params = {
          id: row.id,
          targetSent: el.target.innerText
        };
        if (fouceText === el.target.innerText) {
          return;
        }
        if (this.bankType === 'memory') {
          res = await updateMemoryBank(params)
        } else {
          res = await updateTermBank(params)
        }
        if (res.success) {
          this.$message.closeAll();
          this.$message.success(this.$t("memoryBankV2.Translationmodifiedsuccessfully"));
        }
      })
    },
    fromatelangDesc(langDesc, sourceLang, targetLang) {
      return this.$i18n.locale === 'zh' ? langDesc.replace('>', " — ") : this.$langCase[sourceLang] + ' — ' + this.$langCase[targetLang]
    },
    mouseOverShowTips(e) {
      let target = e.target
      let textLength = target.clientWidth
      let containerLength = target.scrollWidth
      if (textLength < containerLength) {
        this.showTitle = false;
      } else {
        this.showTitle = true;
      }
    },
    indexMethod(index) {
      if (index < 9) {
        index += 1;
        return "0" + index;
      } else {
        return index + 1;
      }
    },
    handlerScroll() {
      const contentWarpp = this.$refs.contentWarpp
      let scrollTop = contentWarpp.scrollTop
      // 变量windowHeight是可视区的高度
      let windowHeight = contentWarpp.clientHeight || contentWarpp.clientHeight
      // 变量scrollHeight是滚动条的总高度
      let scrollHeight = contentWarpp.scrollHeight || contentWarpp.scrollHeight
      if (scrollTop + windowHeight === scrollHeight) {
        this.params.page++;
        if (this.params.page > this.totalPage) {
          return
        }
        this.getmemoryDeduplication(this.params.page);
      }
    },
    async  getmemoryDeduplication(page) {
      let res = null;
      this.params.page = page;
      if (this.bankType === 'memory') {
        res = await memoryDeduplication(this.params)
      } else {
        res = await termDeduplication(this.params)
      }
      if (res.success) {
        this.totalPage = res.result.totalPage;
        this.totalRows = res.result.totalRows
        this.pendingList = this.pendingList.concat(res.result.sentList);
        res.result.sentList.forEach((item, index) => {
          item.targetSentList.forEach(key => {
            this.$set(key, 'check', false)
            this.$set(key, "index", index)
          })
        })
      }
    },
    handleClose() {
      this.$refs.contentWarpp.scrollTop = 0;
      this.pendingList.length = 0;
      this.$emit('handleClose')
    },
    //处理
    async handle() {
      let idList = [];
      let checkList = [];
      let ischeck = false;
      this.pendingList.forEach(item => {
        if (item.targetSentList && item.targetSentList.length) {
          item.targetSentList.forEach(key => {
            if (key.check) {
              ischeck = true
              checkList.push(key)
            }
          })
        }
      })
      checkList.forEach(item => {
        this.pendingList.forEach((child, index) => {
          if (item.index === index) {
            if (child.targetSentList && child.targetSentList.length) {
              child.targetSentList.forEach(k => {
                if (!k.check) {
                  idList.push(k.id)
                }
              })
            }
          }
        })
      })
      let res = null;
      if (!ischeck) {
        this.$message.closeAll();
        this.$message.warning(this.$t('memoryBankV2.Pleasecheckthecorpustobedeleted'))
        return;
      }
      if (idList.length === 0) {
        this.$emit('handle')
        this.duplicateremovalsuccessVisible = true;
        this.pendingList = [];
        return
      }
      if (this.bankType === 'memory') {
        res = await DeleteByIdList({ idList })
      } else {
        res = await termDeleteByIdList({ idList })
      }
      if (res.success) {
        this.$emit('handle')
        this.duplicateremovalsuccessVisible = true;
        this.pendingList = [];
      }
    },
    //关闭去重
    closeduplicateremoval() {
      this.duplicateremovalsuccessVisible = false;
      this.pendingList = [];
    }
  }
}
</script>
<style lang="less" scoped>
.duplicateremovalPending {
  /deep/.duplicateremovalPending {
    width: 652px;
    background: #ffffff;
    box-shadow: 0px 10px 28px 1px rgba(51, 51, 51, 0.18);
    border-radius: 4px 4px 4px 4px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0px !important;
    .el-dialog__header {
      padding: 16px 32px;
    }
    .el-dialog__footer {
      padding: 24px 0px 32px 0px;
      .el-button + .el-button {
        margin-left: 16px;
      }
    }
    .el-dialog__body {
      padding: 0px;
      .duplicateremovalPending-content {
        width: 100%;
        height: 100%;
        padding: 0 36px;
        box-sizing: border-box;
        ul {
          width: 100%;
          height: 515px;
          overflow-y: auto;
          padding-right: 10px;
          li {
            width: 100%;
            .source {
              height: 28px;
              display: flex;
              justify-content: space-between;
              margin-bottom: 16px;
              .source-l {
                display: flex;
                .source-box {
                  width: max-content;
                  padding: 6px 8px;
                  box-sizing: border-box;
                  height: 28px;
                  background: #ecf3fe;
                  border-radius: 4px 4px 4px 4px;
                  line-height: 16px;
                  font-size: 12px;
                  font-weight: 400;
                  color: #65a9e4;
                }
                .source-content {
                  width: 300px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  margin-left: 4px;
                  font-size: 12px;
                  font-weight: 400;
                  color: #303133;
                  line-height: 27px;
                }
              }
              .source-r {
                display: flex;
                .sourec-item {
                  width: 83px;
                  height: 28px;
                  background: #f2f3f5;
                  border-radius: 4px 4px 4px 4px;
                  font-size: 12px;
                  font-weight: 400;
                  color: #909399;
                  text-align: center;
                  line-height: 28px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  padding: 0 8px;
                  box-sizing: border-box;
                }
                .lang {
                  width: 93px;
                }
                .sourec-item + .sourec-item {
                  margin-left: 10px;
                }
              }
            }
            .target-table {
              .tableheader {
                th {
                  background: #f5f7fa;
                  font-size: 14px;
                  font-weight: 400;
                  color: #303133;
                  padding: 0px;
                }
              }
              .el-table__body-wrapper {
                height: 100% !important;
              }
              .el-table__body {
                tbody {
                  tr > td {
                    height: 100%;
                    padding: 0px;
                    div {
                      word-break: break-word;
                      white-space: normal;
                      .target-content {
                        height: 100%;
                        min-height: 36px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #303133;
                        text-align: left;
                        padding: 12px 0;
                      }
                    }
                  }
                }
              }
            }
          }
          li + li {
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>